<div class="content container text-primary" *ngIf="product">
<!-- 
	<ascedia-loading-status icon="true" [loading]="loading" className="pl-3"></ascedia-loading-status> -->

	<form [formGroup]="reviewForm" (ngSubmit)="onSubmit()" >

		<div class="container-fluid px-0 ml-0">
			
			<div class="row no-gutters">				
				<div class="col-12 col-md-9 col-lg-10">
					<div class="tab-group-content">
						<div class="tab-group-content-inner active" >
							<div class="tab-group-content-inner pt-3 active" >
								<h3 class="font-weight-bold">Write a Review for {{product.name}}</h3>									
								<input type="hidden" class="form-control disabled" formControlName="productId" hidden>	
								<input type="hidden" class="form-control" formControlName="createdOn">
								<input type="hidden" class="form-control" formControlName="modifiedOn">
								<input type="hidden" class="form-control" formControlName="userId">	
								
								<div class="" formGroupName="response">
									<textarea  class="form-control" formControlName="content" rows="3" hidden></textarea>
									<input type="hidden" class="form-control" formControlName="createdOn">
									<input type="hidden" class="form-control" formControlName="userId">
								</div>
							</div>

							<div class="mt-5">
								<div class="row">
									<div class="col-12 mb-3">
										<label class="form-label">Headline</label>
										<input type="text" class="form-control" formControlName="headline" required>
										<div *ngIf="(!review.headline && attemptedSubmit)" class="alert alert-danger">Headline is required</div>
									</div>
								</div>
				
								<div class="row">
									<div class="col-12 mb-3">
										<label class="form-label">Content</label>
										<textarea class="form-control" formControlName="content" rows="3" required></textarea>
										<div *ngIf="(!review.content && attemptedSubmit)" class="alert alert-danger">Content is required</div>
									</div>
								</div>
								<div class="row">
									<div class="col-12 mb-3">
										<label class="form-label">Display Name</label>
										<input type="text" class="form-control" formControlName="userDisplayName">
									</div>
								</div>
								<div class="row">
									<div class="col-12 col-md-6 mb-3">
										<label class="form-label">Rating</label>
										<input type="hidden" class="form-control" formControlName="rating">
										<div class="reviews mt-2">
											<div class="rating mr-2 d-inline-block">
												<button class="mb-2" type="button" [ngClass]="{'icon-circle-white': review.rating == 1, 'icon-circle-primary': review.rating == 0}" (click)="flipRating(1)">
													<fa-icon [icon]="['fas','thumbs-up']" class=""></fa-icon>
												</button>
											</div>
											<div class="rating d-inline-block">						
												<button class="mb-2" type="button" [ngClass]="{'icon-circle-white': review.rating == 0, 'icon-circle-primary': review.rating == 1}" (click)="flipRating(0)">
													<fa-icon [icon]="['fas','thumbs-down']"></fa-icon>
												</button>
											</div>

										</div>
									</div>
								</div>	
							</div>
							<div class="my-3">
								<div class="d-flex">
									<app-btn-save text="Submit Review" [isDisabled]="submitSuccessful"></app-btn-save>										
								</div>		
								<app-response-message [responseMsg]="responseMsg" *ngIf="responseMsg"></app-response-message>
	
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
